/**
 * Skills, read-only: one line each, its name and whether today's run used it, with the description
 * behind an ⓘ. A skill
 * the server found invalid says why, in the server's words; it is left out of the agent's index.
 * The team edits skills in git, never here.
 */

import type { Skills as SkillsPayload } from "../../api/types/competition";
import { useT } from "../../i18n/useT";
import { Info } from "../ui/Info";

export function Skills({ skills, tradeDate }: { skills: SkillsPayload; tradeDate: string | null }) {
  const { t } = useT();
  const used = new Set(skills.used.find((u) => u.trade_date === tradeDate)?.skills_used ?? []);

  if (!skills.skills.length) return <p className="empty">{t("skills.none")}</p>;

  return (
    <ul className="skills">
      {skills.skills.map((s) => {
        const tag = !s.valid ? "invalid" : used.has(s.name) ? "used" : "unused";
        return (
          <li key={s.name} className="skill" data-skill={s.name} data-tag={tag}>
            <span className="skill__head">
              <span className="mono skill__name">{s.name}</span>
              {s.description ? <Info term={s.name} text={s.description} /> : null}
              <span className="skill__tag">
                {tag === "invalid"
                  ? `${t("skills.invalid")}: ${s.problem ?? ""}`
                  : tag === "used"
                    ? t("skills.used")
                    : t("skills.unused")}
              </span>
            </span>
          </li>
        );
      })}
    </ul>
  );
}
